import React, { useContext, useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import { Container, Row, Col } from 'react-bootstrap'
import GlobalContext from '../../Context/Context'

// Import Assets
import logoLight from '../../Assets/img/imigo-logo.png'

const FooterImigo = () => {
  const { setFooterHeight } = useContext(GlobalContext);
  const footerRef = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      setFooterHeight(footerRef.current.offsetHeight);
    }, 1000);

    window.addEventListener('resize', () => {
      setTimeout(() => {
        setFooterHeight(footerRef.current.offsetHeight);
      }, 1000);
    });
  }, [setFooterHeight]);

  return (
    <footer ref={footerRef} className="footer-imigo py-[60px] bg-darkgray text-white">
      <Container>
        <Row className="justify-content-between">
          <Col lg={4} md={6} className="mb-[30px]">
            <Link to="/" className="mb-[20px] inline-block">
              <img src={logoLight} alt="Imigo Logo" className="h-[60px] w-auto" />
            </Link>
            <p className="mb-[20px]">
              Imigo is your smart migration assistant, connecting you with resources, communities, and tools to make your migration journey smoother and more human.
            </p>
            <div className="social-icons">
              <a href="https://instagram.com/imigo.app" target="_blank" rel="noopener noreferrer" className="mr-[15px]">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="https://twitter.com/imigoapp" target="_blank" rel="noopener noreferrer" className="mr-[15px]">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="https://linkedin.com/company/imigo" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-linkedin-in"></i>
              </a>
            </div>
          </Col>
          <Col lg={2} md={6} className="mb-[30px]">
            <h6 className="font-bold mb-[20px] text-white">Quick Links</h6>
            <ul className="pl-0 list-none">
              <li className="mb-[10px]">
                <Link to="/" className="text-white hover:text-neonorange transition-all duration-300">Home</Link>
              </li>
              <li className="mb-[10px]">
                <Link to="/articles" className="text-white hover:text-neonorange transition-all duration-300">Articles</Link>
              </li>
              <li className="mb-[10px]">
                <Link to="/businesses" className="text-white hover:text-neonorange transition-all duration-300">Businesses</Link>
              </li>
              <li className="mb-[10px]">
                <Link to="/events" className="text-white hover:text-neonorange transition-all duration-300">Events</Link>
              </li>
              <li className="mb-[10px]">
                <Link to="/marketplace" className="text-white hover:text-neonorange transition-all duration-300">Marketplace</Link>
              </li>
            </ul>
          </Col>
          <Col lg={2} md={6} className="mb-[30px]">
            <h6 className="font-bold mb-[20px] text-white">Resources</h6>
            <ul className="pl-0 list-none">
              <li className="mb-[10px]">
                <Link to="/forum" className="text-white hover:text-neonorange transition-all duration-300">Forum</Link>
              </li>
              <li className="mb-[10px]">
                <Link to="/activities" className="text-white hover:text-neonorange transition-all duration-300">Activities</Link>
              </li>
              <li className="mb-[10px]">
                <Link to="/about" className="text-white hover:text-neonorange transition-all duration-300">About Us</Link>
              </li>
              <li className="mb-[10px]">
                <Link to="/contact" className="text-white hover:text-neonorange transition-all duration-300">Contact</Link>
              </li>
              <li className="mb-[10px]">
                <Link to="/privacy" className="text-white hover:text-neonorange transition-all duration-300">Privacy Policy</Link>
              </li>
            </ul>
          </Col>
          <Col lg={3} md={6} className="mb-[30px]">
            <h6 className="font-bold mb-[20px] text-white">Download Our App</h6>
            <p className="mb-[20px]">Get the full Imigo experience with our mobile app</p>
            <div className="app-buttons">
              <a href="https://apps.apple.com/us/app/imigo-connect/id6744267446" target="_blank" rel="noopener noreferrer" className="btn btn-outline-light mb-[10px] mr-[10px]">
                <i className="fab fa-apple mr-[5px]"></i> iOS App
              </a>
              <a href="https://play.google.com/store/apps/details?id=app.imigo" target="_blank" rel="noopener noreferrer" className="btn btn-outline-light mb-[10px]">
                <i className="fab fa-google-play mr-[5px]"></i> Android App
              </a>
            </div>
          </Col>
        </Row>
        <div className="border-t border-[#444] mt-[30px] pt-[30px] text-center">
          <p className="mb-0">&copy; {new Date().getFullYear()} Imigo. All Rights Reserved.</p>
        </div>
      </Container>
    </footer>
  )
}

export default FooterImigo 